import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-12 md:py-16 lg:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          {/* Content */}
          <div className="flex-1 w-full max-w-xl lg:max-w-none">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm font-medium mb-3">
              <i className="ri-smartphone-line"></i>
              <span>随时随地</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 md:mb-6">
              {appData.description}
            </p>

            <ul className="space-y-3 mb-6 md:mb-8">
              {appData.features.map((feature, idx) => (
                <li key={idx} className="flex items-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                    <i className="ri-check-line text-primary-600 text-sm"></i>
                  </div>
                  <span className="text-sm md:text-base text-foreground-700">{feature}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <button
                type="button"
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-apple-line"></i>
                App Store 下载
              </button>
              <button
                type="button"
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg border-2 border-foreground-300 text-foreground-700 font-semibold text-sm hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-android-line"></i>
                安卓版下载
              </button>
            </div>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-sm lg:max-w-md img-container">
            <img
              src={appData.image}
              alt="香蕉漫画网移动端界面展示"
              className="w-full h-auto rounded-2xl object-cover"
              onError={(e) => {
                const container = e.currentTarget.closest('.img-container');
                if (container) container.classList.add('hidden');
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}